module.exports = __webpack_public_path__ + "img/turkcell-foursquare-launch-04.bfc1f733.jpg";